// removed by extract-text-webpack-plugin
module.exports = {"title":"statistics_title_2v1gr","barChart":"statistics_barChart_3FwRI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/state/statistics.scss
// module id = 1571
// module chunks = 0